// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import { PokerTokenIcon } from '../../assets/img/betting';
import { __ } from '../../i18n/l10n';
import FontSize from '../../renderprops/FontSize';
import theme from '../../styled-components/dark';
import Spritesheet from '../Spritesheet';

const Wrap = styled.div`
  position: relative;
  display: inline-block;
  border: solid 1px ${theme.PokerButton.borderColor};
  border-radius: 0.4em;
  cursor: pointer;
  user-select: none;
`;

const InnerWrap = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Text = styled.span`
  font-family: 'BettingCountbach', sans-serif;
  text-transform: uppercase;
  color: ${theme.PokerButton.color};
  padding: 0.25em 0.4em 0.4em 0;
  margin: 0;
  background: linear-gradient(to top, #ffa800 1%, #ffd000 61%, #fffe00 83%);
  -webkit-background-clip: text;
  -moz-background-clip: text;
  -webkit-text-fill-color: transparent;
  -moz-text-fill-color: transparent;
`;

const StyledSpritesheet = styled(Spritesheet)`
  margin: 0 0.4em 0 0.4em;
`;

type Props = {
  className?: string;
  onClick?: () => void;
  animate: number;
};

const PokerButton = ({ className, animate = 0, onClick = () => {} }: Props) => {
  return (
    <FontSize>
      {({ fontSize }) => (
        <Wrap id={'winabet-poker-button'} className={className} onClick={onClick}>
          <InnerWrap>
            <StyledSpritesheet
              rowCount={4}
              columnCount={8}
              url={PokerTokenIcon}
              keepRatio
              height={fontSize}
              play={animate}
            />
            <Text>{__('Poker')}</Text>
          </InnerWrap>
        </Wrap>
      )}
    </FontSize>
  );
};

export default PokerButton;
